// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"893":"aee091e0","976":"3ed59ba2"}[chunkId] + ".chunk.js";
};